import { BACKEND_URL } from "../../../../constants";

const URL = `${BACKEND_URL}/graphql`;

const QUERY = `
query (
  $refIds: [ID]!
){
  references(refIds: $refIds, first: 10) {
    edges {
      node {
        id
        isolateObjs {
          patientId
          isolateDate
          dateMatch
          isolateName
          gene
          isolateType
          host
          species
          subtype
          clinicalIsolate {
            source
            culture
            seqTemplate
            cloneMethod
            seqMethod
          }
          labIsolate {
            parent
            passage
            sdm
            mutationList
          }
          patient {
            pseudoName
            region
          }
          sequences {
            edges {
              node {
                accession
                sequenceType
                drms
                cloneName
                mutationList
                aaseq
                naseq
                firstAa
                lastAa
              }
            }
          }
        }
      }
    }
  }
}
`;


export default async function API(refID) {
  if (!refID) {
    return [];
  }
  refID = btoa(`Reference:${refID}`);
  const request = new Request(
    URL,
    {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        query: QUERY,
        variables: {
          refIds: [refID]
        }
      })
    });

  const resp = await fetch(request);
  const {data} =  await resp.json();

  return data;
}



// WEBPACK FOOTER //
// ./src/views/wizard/isolate/hivdb/reference-api.js